"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HealthIcon = require("./HealthIcon");

var _HealthIcon2 = _interopRequireDefault(_HealthIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _HealthIcon2.default;